import React, {useEffect, useState} from 'react'
import Loader from "../../Loader/Loader";
import BottomMenu from "../layout/bottomMenu";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import Moment from "moment";
import {toast} from 'react-toastify';
import SuccessModal from "../CustomModal/Success";
import FailedModal from "../CustomModal/Failed";
import $ from "jquery";

const Assignment = ({
                        fetchAssignee,
                        getAssignee = [],
                        changeAssignee,
                        ChangeAssigneeDetails = [],
                        history,
                        assgineeAccount,
                        accountAssigneedetails = [],
                        getFilter,
                        accountFilterContent = [],
                        getCityByStateId,
                        geoCity = [],
                        match
                    }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [accountIds, setAccountIds] = useState([])
    const [assignedTo, setAssignedTo] = useState('')
    const [filterInputList, setFilterInputList] = useState([{}])
    const [filterView, setfilterView] = useState([{}])
    const [requiredDataOnChange, setRequiredDataOnChange] = useState([{City: ''}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [open, setOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false)
    const [searchValue, setSearchValue] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await fetchAssignee()
            await assgineeAccount()
            await getFilter()
            setIsLoading(false)
        })()
    }, [])

    const handleFilter = async (key, value, stringValue = '') => {

        if (key === 'state') {
            await getCityByStateId(value)
        }
        const list = [...filterInputList]
        const view = [...filterView]
        list[0][key] = value
        view[0][key] = value
        if (stringValue !== '') {
            view[0][key] = stringValue
            setfilterView(view)
        } else {
            setfilterView(view)
        }
        setFilterInputList(list)
    }

    useEffect(() => {
        if (geoCity && geoCity?.data !== undefined) {
            requiredDataOnChange[0]['City'] = geoCity?.data
            setRequiredDataOnChange(requiredDataOnChange)
        }
    }, [geoCity, accountFilterContent])

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await assgineeAccount(filterInputList)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterView[0][key]
            delete filterInputList[0][key]
            delete filterInputList[0][key + "_name"]
            setfilterView(filterView)
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await assgineeAccount(filterInputList)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setfilterView([{}])
                setFilterInputList([{}])
                setIsLoading(true)
                await assgineeAccount(filterInputList)
                setIsLoading(false)
                setIsRemoveFilter(false)
            }

        })()
    }, [isFilterRemove])

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (ChangeAssigneeDetails?.status === 200) {
            setIsSuccessModalOpen(true)
        } else if (ChangeAssigneeDetails?.status !== undefined && ChangeAssigneeDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [ChangeAssigneeDetails])

    const handleAddAccount = (e, id) => {
        if(e.target.checked){
            accountIds.push(parseInt(id))
            setAccountIds(accountIds)
        } else{
            let index = accountIds.indexOf(parseInt(id));
            if (index !== -1) {
                accountIds.splice(index, 1);
            }
            setIsAllChecked(false)
            setAccountIds(accountIds)
        }
    }

    const handleAssignee = async (e) => {
        e.preventDefault()


        if (assignedTo === '') {
            toast.error("Please select assignee")
            return false
        }

        if(isAllChecked && accountAssigneedetails && accountAssigneedetails?.data !== undefined){
            // eslint-disable-next-line no-unused-expressions
            accountAssigneedetails?.data.map((element) => {
                accountIds.push(element?.id)
            })
        }

        if (accountIds.length === 0) {
            toast.error("Please select accounts to assign")
            return false
        }

        let request = {
            ids: accountIds,
            assigned_user: assignedTo
        }
        setIsLoading(true)
        await changeAssignee(request)
        setIsLoading(false)
    }

    const makeAllChecked = (e) => {
        if(e.target.checked){
            setIsAllChecked(true)
            $("input[type=checkbox]").prop('checked', true)
        }else{
            setIsAllChecked(false)
            setAccountIds([])
            $("input[type=checkbox]").prop('checked', false)
        }
    }

    const handleKeyDown = async (event) => {
        if (event.key === 'Enter' && searchValue !== '') {
            event.preventDefault()
            setIsLoading(true)
            await assgineeAccount(filterInputList, searchValue)
            setIsLoading(false)
        }
    }

    const handleSearch = async () => {
        if (searchValue === '') {
            return false
        }
        setIsLoading(true)
        await assgineeAccount(filterInputList, searchValue)
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={ChangeAssigneeDetails?.message}
                url={'assignment'}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={ChangeAssigneeDetails?.message}
            />

            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            history={history}
                            title={'Assign Acc.'}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between">
                                    {/*<div className="row col-md-12">*/}
                                    {/*    <div className="col-md-6 col-sm-6 d-flex mt-20px">*/}
                                    {/*        <h3 className="h3 mb-0 text-black-100">Account Assignment </h3>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="d-sm-flex align-items-center justify-content-between">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">
                                            <form className="form-inline mr-auto navbar-search">
                                                <div className="d-flex w-100">
                                                    <div className="col-sm-3 mt-1 float-field">
                                                        <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                                setAssignedTo(e.target.value)
                                                            }} required>
                                                            <option value="">Select Assignee
                                                            </option>
                                                            {getAssignee.length > 0 && getAssignee.map((val) => {
                                                                return (
                                                                    <option
                                                                        value={val?.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </select>
                                                        <label className="large-label float-lb">
                                                            Assignee
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-3 mt-1 float-field d-flex">
                                                        <input type="text"
                                                               className="form-control bg-light border-0 small list-filter"
                                                               placeholder={"Search Account..."}
                                                               aria-label="Search"
                                                               aria-describedby="basic-addon2"
                                                               onChange={(e) => {
                                                                   setSearchValue(e.target.value)
                                                               }}
                                                               onKeyDown={handleKeyDown}
                                                        />
                                                        <div className="btn-search" style={{marginRight: "22px"}}>
                                                            <button className="btn btn-primary lh-32 border-left-tr-tb"
                                                                    type="button"
                                                                    onClick={(e) => handleSearch()}
                                                            >
                                                                <i className="fas fa-search fa-sm"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-md-6 cs-pos ">
                                            <button onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter btn-filter-2"
                                                    type="button"><i
                                                className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {filterView[0] !== undefined && Object.keys(filterView[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between">
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterView[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform:"capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - "+filterView[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {handleRemoveFilter(val)}}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="card-body">
                                                <div className="user mt-4">
                                                    <div className="form-group row">
                                                        {/*<div className="col-sm-6 mt-1 float-field">*/}
                                                        {/*    <select*/}
                                                        {/*        className="form-control form-control-user"*/}
                                                        {/*        onChange={(e) => {*/}
                                                        {/*            setAssignedTo(e.target.value)*/}
                                                        {/*        }} required>*/}
                                                        {/*        <option value="">Select Assignee*/}
                                                        {/*        </option>*/}
                                                        {/*        {getAssignee.length > 0 && getAssignee.map((val) => {*/}
                                                        {/*            return (*/}
                                                        {/*                <option*/}
                                                        {/*                    value={val?.id}>{val.name}</option>*/}
                                                        {/*            )*/}
                                                        {/*        })}*/}
                                                        {/*    </select>*/}
                                                        {/*    <label className="large-label float-lb">*/}
                                                        {/*        Assignee*/}
                                                        {/*    </label>*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row notification-lists">
                                            <div className="col-md-12">
                                                <div className="notification-ui_dd-content noty">
                                                    <div className="" style={{marginLeft:"91%", width:"4%"}}>
                                                        <input type="checkbox"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   // handleInput('next_activity_date', e.target.value, e)
                                                               }}
                                                               onClick={(e) => makeAllChecked(e)}
                                                               value={""}
                                                               id="validationCustom01"
                                                        />
                                                    </div>
                                                    {accountAssigneedetails && accountAssigneedetails?.data !== undefined && accountAssigneedetails?.data.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div
                                                                    className="notification-list notification-list--unread">
                                                                    <div className="notification-list_content">
                                                                        {/* <div class="notification-list_img"> <img src="images/users/user1.jpg" alt="user" /> </div> */}
                                                                        <div className="notification-list_detail">
                                                                            <p className="green"><b
                                                                                className="title-color">{val?.client_name}</b>{"( " + val?.project_name + " )"}
                                                                            </p>
                                                                            <p className="text-muted">
                                                                                <small><i>{Moment(val?.created_at).format('DD-MMMM-YYYY')} ({"Assigned To: " + val?.assgined_user})</i></small>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="">
                                                                        <input type="checkbox"
                                                                               className="form-control form-control-user"
                                                                               placeholder=" "
                                                                               onChange={(e) => {
                                                                                   // handleInput('next_activity_date', e.target.value, e)
                                                                               }}
                                                                               onClick={(e) => handleAddAccount(e, val?.id)}
                                                                               value={""}
                                                                               id="validationCustom01"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-12 mt-4 d-flex">
                                            <button className="btn btn-primary btn-user btn-block submit-btn"
                                                    onClick={(e) => {
                                                        handleAssignee(e)
                                                    }}>
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    filterContent={accountFilterContent}
                    handleFilter={handleFilter}
                    handleSubmitFilter={handleSubmitFilter}
                    requiredDataOnChange={requiredDataOnChange}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default Assignment